import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  type BlueprintResponse,
  type CareerPathFitCategory,
} from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

const { coachingAnalytics } = appStrings.modules;

export const useAgentContext = (
  data: BlueprintResponse,
  rankedCategories: readonly CareerPathFitCategory[],
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: coachingAnalytics.blueprint.title,
    description: coachingAnalytics.blueprint.subtitle,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.blueprint.uniqueBlueprints.title,
    display:
      'Completed Blueprint count out of all students, with the share recommended entrepreneurship.',
    detail: [
      coachingAnalytics.blueprint.uniqueBlueprints.info,
      coachingAnalytics.blueprint.uniqueBlueprints.entrepreneurshipInfo,
    ].join('\n\n'),
    data: {
      students: data.students.total,
      unique_blueprints: data.unique_blueprints,
      entrepreneurship_recommended: data.entrepreneurship_recommended,
    },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.blueprint.targetCareerTracks.title,
    display: 'Donut of Target Career Track shares.',
    detail: coachingAnalytics.blueprint.targetCareerTracks.info,
    data: data.target_career_tracks,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.blueprint.careerPathFit.title,
    display: 'One stacked bar per career category, ranked by how many students fit it strongly.',
    detail: [
      coachingAnalytics.blueprint.careerPathFit.info,
      'Broad strong fit across many categories is expected — many career paths genuinely fit many students — so wide strong-fit counts are the assessment working as designed, not a flaw.',
    ].join('\n\n'),
    data: {
      total: data.career_path_fit.total,
      categories: rankedCategories.map((category) => ({
        name: category.name,
        students: category.students,
      })),
    },
  });
};
